import React, { useMemo } from 'react'
import { Box, Step, StepLabel, Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import StepperMui from '@mui/material/Stepper'
import Image from 'next/image'
import { useRouter } from 'next/router'

import { steps } from '../../lib/constants'
import { switchPreviousStep } from '../../model/stepper-slice'
import { StepContact } from '../step-contact/step-contact'
import { StepInformation } from '../step-information/step-information'
import { StepLegalInformative } from '../step-legal-informative/step-legal-informative'

import styles from './stepper.module.scss'

import { useAppDispatch, useAppSelector } from '#/app/store/store'
import { useShowDataStore } from '#/shared/lib/hooks/use-show-data'

export const Stepper = () => {
	const activeStep = useAppSelector((state) => state.stepper.activeStep)
	const loadingCreate = useAppSelector((state) => state.stepper.loadingCreate)
	const processCreate = useAppSelector((state) => state.stepper.loadingCreate)

	const dispatch = useAppDispatch()

	const { showMessage } = useShowDataStore()
	const { push } = useRouter()

	React.useEffect(() => {
		if (processCreate === 'failed') {
			showMessage('Ошибка создания аккаунта')
		}

		if (processCreate === 'succeeded') {
			void push('/account')
		}
	}, [processCreate, push, showMessage])

	const isShowBackBtn = activeStep !== 0

	const stepButtons = useMemo(
		() =>
			steps.map((label, idx) => (
				<Step
					key={label}
					sx={{
						'.MuiStepLabel-root': {
							cursor: 'default',
							pointerEvents: 'none',
						},
						'.MuiStepLabel-root .MuiStepLabel-label': {
							cursor: 'default',
						},
						'.MuiSvgIcon-root': {
							cursor: 'default',
						},
					}}
				>
					<StepLabel>{label}</StepLabel>
				</Step>
			)),
		[]
	)

	return (
		<Box className={styles.wrapper}>
			<>
				{loadingCreate === 'pending' ? (
					<CircularProgress
						size={25}
						thickness={5}
						sx={{
							color: '#7F7DF3',
						}}
					/>
				) : (
					<Box className={styles.wrapperStepper}>
						{isShowBackBtn && (
							<Image
								onClick={() => dispatch(switchPreviousStep())}
								className={styles.back}
								src={'/svg/business/back-register.svg'}
								width={31}
								height={26}
								alt={'Назад'}
							/>
						)}
						<Typography className={styles.title}>Регистрация корпоративного аккаунта</Typography>
						<StepperMui activeStep={activeStep} className={styles.stepper} alternativeLabel>
							{stepButtons}
						</StepperMui>
						<Box className={styles.model}>
							<Box sx={{ display: activeStep === 0 ? 'contents' : 'none' }}>
								<StepInformation />
							</Box>
							<Box sx={{ display: activeStep === 1 ? 'contents' : 'none' }}>
								<StepLegalInformative />
							</Box>
							<Box sx={{ display: activeStep === 2 ? 'contents' : 'none' }}>
								<StepContact />
							</Box>
						</Box>
					</Box>
				)}
			</>
		</Box>
	)
}
